var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ai-common-settings',{attrs:{"is-group":true},on:{"submit":_vm.updateSettings},scopedSlots:_vm._u([{key:"ai-common-settings-top",fn:function(){return [(_vm.showEarlyAccessBanner)?_c('early-access-program-banner'):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }